module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/BasicContent-01aa6f0b95c1a9fcab7f3fedda520190.png";